import { formatMonthName } from 'utils/formatting/formateMonthName/formateMonthName'
import { checkDateIsEqual } from 'utils/helpers/date/checkDateIsEqual'
import { useCalendar } from 'utils/hooks/useCalendar'

import ToggleIcon from 'assets/img/caret--black.svg?react'
import s from './AdminCalendar.module.scss'

type AdminCalendarProps = {
  state: ReturnType<typeof useCalendar>['state']
}

export const AdminCalendar = ({ state }: AdminCalendarProps) => {
  return (
    <div className={s.wrap}>
      <h5>
        Выбрана дата - {state.selectedDate.dayNumber} {formatMonthName(state.selectedDate.monthName)}
        {', '}
        {state.selectedDate.year}
      </h5>

      <div className={s.calendar}>
        <header className={s.header}>
          <button onClick={() => state.onClickArrow('left')}>
            <ToggleIcon className={s.toggleIcon} />
          </button>

          {state.mode === 'days' && (
            <p className={s.headerText} onClick={() => state.setMode('months')}>
              {state.monthNames[state.selectedMonth.monthIndex].monthName} {state.selectedYear}
            </p>
          )}

          {state.mode === 'months' && (
            <p className={s.headerText} onClick={() => state.setMode('years')}>
              {state.selectedYear}
            </p>
          )}

          {state.mode === 'years' && (
            <p>
              {state.selectedYearsInterval[0]} - {state.selectedYearsInterval[state.selectedYearsInterval.length - 1]}
            </p>
          )}

          <button onClick={() => state.onClickArrow('right')}>
            <ToggleIcon className={`${s.toggleIcon} ${s.rotate}`} />
          </button>
        </header>

        <main className={s.main}>
          {state.mode === 'days' && (
            <>
              <div className={s.weekDays}>
                {state.weekDayNames.map((weekDaysName) => (
                  <div key={weekDaysName.dayShort}>{weekDaysName.dayShort}</div>
                ))}
              </div>

              <div className={s.days}>
                {state.visibleDays.map((day) => {
                  const isToday = checkDateIsEqual(day.date, new Date())
                  const isSelectedDay = checkDateIsEqual(day.date, state.selectedDate.date)
                  const isAdditionalDay = day.monthIndex !== state.selectedMonth.monthIndex

                  return (
                    <div
                      key={`${day.dayNumber}-${day.monthIndex}`}
                      onClick={() => state.setSelectedDate(day)}
                      className={[
                        s.day,
                        isToday ? s.isToday : '',
                        isSelectedDay ? s.isSelectedDay : '',
                        isAdditionalDay ? s.isAdditionalDay : '',
                        day.conferences.length > 0 ? s.dayWithConference : '',
                      ].join(' ')}
                    >
                      {day.dayNumber}
                    </div>
                  )
                })}
              </div>
            </>
          )}

          {state.mode === 'months' && (
            <div className={s.pickItemsWrap}>
              {state.monthNames.map((monthName) => {
                const isCurrentMonth =
                  new Date().getMonth() === monthName.monthIndex && state.selectedYear === new Date().getFullYear()
                const isSelectedMonth = monthName.monthIndex === state.selectedMonth.monthIndex

                return (
                  <div
                    key={monthName.monthIndex}
                    onClick={() => {
                      state.setMonthIndex(monthName.monthIndex)
                      state.setMode('days')
                    }}
                    className={[
                      s.pickItem,
                      isSelectedMonth ? s.isSelectedDay : '',
                      isCurrentMonth ? s.isToday : '',
                    ].join(' ')}
                  >
                    {monthName.monthShort}
                  </div>
                )
              })}
            </div>
          )}

          {state.mode === 'years' && (
            <div className={s.pickItemsWrap}>
              <div className={s.unClosableYear}>{state.selectedYearsInterval[0] - 1}</div>

              {state.selectedYearsInterval.map((year) => {
                const isCurrentYear = new Date().getFullYear() === year
                const isSelectedYear = year === state.selectedYear

                return (
                  <div
                    key={year}
                    onClick={() => {
                      state.setSelectedYear(year)
                      state.setMode('months')
                    }}
                    className={[s.pickItem, isCurrentYear ? s.isToday : '', isSelectedYear ? s.isSelectedDay : ''].join(
                      ' ',
                    )}
                  >
                    {year}
                  </div>
                )
              })}

              <div className={s.unClosableYear}>
                {state.selectedYearsInterval[state.selectedYearsInterval.length - 1] + 1}
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  )
}
